import axios from '../axios';
import type {
  ApiEnvelope,
  Identifier,
  ListParams,
  PaginatedResponse,
  ProviderManproProjectDto,
} from './types';

const API_URL = '/v1/provider/manpro/projects';

const providerProjectService = {
  async getProviderProjects(params?: ListParams) {
    // API ini khusus role provider: hanya project MANPRO dari bid yang sudah diterima Owner.
    const response = await axios.get<ApiEnvelope<PaginatedResponse<ProviderManproProjectDto> | ProviderManproProjectDto[]>>(
      API_URL,
      { params },
    );

    return response.data.content;
  },

  async getProviderProject(projectId: Identifier) {
    const response = await axios.get<ApiEnvelope<ProviderManproProjectDto>>(`${API_URL}/${projectId}`);
    return response.data.content;
  },

  async completeProject(projectId: Identifier) {
    const response = await axios.post<ApiEnvelope<any>>(`${API_URL}/${projectId}/complete`);
    return response.data;
  },

  async requestHandover(projectId: Identifier) {
    const response = await axios.post<ApiEnvelope<any>>(`${API_URL}/${projectId}/request-handover`);
    return response.data;
  },
};

export default providerProjectService;
